<template>
  <div class="login">
    <van-nav-bar
        title="登录"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit" ref="form">
      <van-field
          v-model="user.username"
          name="username"
          maxlength="6"
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
      >
        <i slot="left-icon" class="iconfont icon-yonghu"></i>
      </van-field>
      <van-field
          v-model="user.tel"
          name="tel"
          placeholder="请输入手机号"
          :rules="telRules"
          type="number"
          maxlength="11"
      >
        <i slot="left-icon" class="iconfont icon-shouji"></i>
      </van-field>
      <van-field
          readonly
          clickable
          name="picker"
          :value="user.orgName"
          placeholder="点击选择项目"
          @click="showPicker = true"
      >
        <i slot="left-icon" class="iconfont icon-zuzhijiegou"></i>
      </van-field>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
          v-model="user.code"
          name="code"
          placeholder="请输入验证码"
          :rules="codeRules"
          type="number"
          maxlength="4"
          class="codeRules"
      >
<!--        <i slot="left-icon" class="iconfont icon-yanzhengma" style="display:inline-block;margin-top: 5px"></i>-->
<!--        <template #button>-->
<!--          <van-button  round  type="primary" v-show="pstatus === 0"  class="" @click="smsHandler"  native-type="button" style="width:100px;height:40px;line-height:40px;"> <span style="font-size: 12px">发送验证码</span></van-button>-->
<!--          <van-button round  type="primary" v-show="pstatus === 1" @click="smsHandler" native-type="button"  style="width:100px;height:40px;line-height:40px;"><span style="font-size: 12px">重新获取</span></van-button>-->
<!--          <van-button round  type="primary" v-show="pstatus === 2" native-type="button" style="width:100px;height:40px;line-height:40px;"><span style="font-size: 12px">{{times}}s</span></van-button>-->
<!--        </template>-->
        <i slot="left-icon" class="iconfont icon-yanzhengma" ></i>
        <template #button>
          <van-button  round  size="small" type="primary" v-show="pstatus === 0"  class="" @click="smsHandler"  native-type="button" >发送验证码</van-button>
          <van-button round   size="small" type="primary" v-show="pstatus === 1" @click="smsHandler" native-type="button"  >重新获取</van-button>
          <van-button round   size="small" type="primary" v-show="pstatus === 2" native-type="button">{{times}}s</van-button>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">登录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {sendMessage ,login ,getLoveorglist} from "../../api";
import {Toast} from "vant";

export default {
  name: "login",
  data(){
    return{
      user:{
        username:'',
        orgName:'',
        tel:'',
        code:'' //验证码

      },
      pstatus:0,
      times:60,
      backCode:'',
      telRules: [{
        required: true,
        message: '手机号不能为空',
        trigger: 'onBlur'
      }, {
        // 自定义校验规则
        validator: value => {
          return /^1[3456789]\d{9}$/   .test(value)

        },
        message: '手机格式错误',
        trigger: 'onBlur'
      }],
      codeRules: [{
        required: true,
        message: '请填写验证码',
        trigger: 'onBlur'
      }],
      value:'',
      columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
      showPicker: false,
      orgList:[]
    }
  },
  created() {
    this.getList()
  },
  methods:{
    async getList() {
      const res = await getLoveorglist()
      if(res.code == 200) {
        this.orgList = res.data
        this.selectData()
      }
    },
    selectData() {
      this.columns = this.orgList.map(item => item.orgName)
    },
    onConfirm(value) {
      this.user.orgName = value;
      this.showPicker = false;
    },
    smsHandler(){
      // 局部表单验证
      this.$refs.form.validate('tel').then(() => {
        this.sendMessageInfo(this.user.tel)
      })

    },
    async sendMessageInfo(tel){
      try {
        await this.$refs.form.validate('tel')
        const data = await sendMessage(tel)
        if(data.code == 200){
          this.backCode = data.data
          Toast.success('短信发送成功，请查看');
          this.countDown()
        }
      }catch (e) {
        return console.log('手机格式输入错误',e)
      }

      //
      // else {
      //   Toast.fail('手机号不能为空');
      // }
    },
    //倒计时修改
    countDown:function(){
      var that = this;
      that.pstatus = 2;
      that.times = 60;
      var st = setInterval(function(){
        that.times = that.times - 1;
        if(that.times === 0) {
          clearInterval(st);
          that.pstatus = 1;
        }
      },1000);
    },
    onClickLeft(){
     this.$router.go(-1)
    },
    async onSubmit() {
      const user = this.user
      this.$refs.form.validate().then(() => {
        if(this.backCode != this.user.code){
          Toast('验证码输入不正确');
          return
        }
      }).catch(() => {

      })
      Toast.loading({
        message: '登录中...',
        forbidClick: true,
        duration:0
      });
     try {
      const res = await login(user)
       if(res.code == 200){
         this.$store.commit('setUser',res.data)
         Toast.success('登录成功')
         const curr = localStorage.getItem('preRoute')
         curr ? this.$router.push({ path: curr }): this.$router.push('/')
       }else {
         Toast('登录失败，请重试')
       }

     }catch (err){
       if(err.response.status == 400){
         console.log('手机号或者验证码错误')
       }else{
         console.log('登录失败，请重试',err)
       }

     }
    },
  }
}
</script>
<style>

</style>
<style scoped lang="scss">

.login{
  .iconfont{
    font-size: 37px;
  }
  .icon-yanzhengma{
    display: block;
    margin-top: 10px;
  }
}
</style>
